<template>
  <div class="calendar-wrapper">
    <div class="calendar">
      <div class="calendar-header">
        <h2 class="desktop">Планиране</h2>
        <div class="selected-date desktop">
          <p v-if="activePeriodTab === 0">
            <strong>{{date|formatDay}}</strong>
            <span>, {{date|formatDayOfWeek}} ({{calendars.length}} подобекта)</span>
          </p>
          <p v-if="activePeriodTab === 1">
            <strong>{{firstDay|formatDay}}</strong>
            -
            <strong>{{lastDay|formatDay}}</strong>
          </p>
        </div>
        <div class="mobile-datepicker">
          <div
            class="mobile-datepicker-toggle"
            @click="showMobileDatepicker = !showMobileDatepicker"
          >
            <span v-if="activePeriodTab === 0">{{date|formatDay}}</span>
            <span v-if="activePeriodTab === 1">{{firstDay|formatDay}} - {{lastDay|formatDay}}</span>
            <span class="sienit" :class="{ 'rotate-arrow': showMobileDatepicker}">K</span>
          </div>
          <div class="mobile-datepicker-wrapper left-panel-week-mode" v-show="showMobileDatepicker">
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :minimumView="'day'"
              :highlighted="highlighted"
              :maximumView="'day'"
              :full-month-name="true"
              v-model="date"
            ></datepicker>
          </div>
        </div>
        <div class="calendar-header-left">
          <label class="desktop" for="views1">Изглед по:</label>
          <div class="views" id="views1">
            <button
              class="view left"
              :class="{ 'view-active' : activePeriodTab === 0 }"
              @click="changePeriodTab(0)"
            >
              <span class="desktop">Ден</span>
              <span class="sienit2 mobile-inline">T</span>
            </button>
            <button
              class="view right"
              :class="{ 'view-active' : activePeriodTab === 1 }"
              @click="changePeriodTab(1)"
            >
              <span class="desktop">Седмица</span>
              <span class="sienit2 mobile-inline">S</span>
            </button>
            <!-- <button class="view right" :class="{ 'view-active' : activePeriodTab === 2 }">Месец</button> -->
          </div>
        </div>
      </div>
      <div class="calendar-content">
        <div
          class="left-panel desktop"
          :class="{ 'left-panel-week-mode' : activePeriodTab === 1, 'left-panel-day-mode' : activePeriodTab === 0 }"
        >
          <datepicker
            :language="bg"
            :inline="true"
            :monday-first="true"
            :minimumView="'day'"
            :highlighted="highlighted"
            :maximumView="'day'"
            :full-month-name="true"
            v-model="date"
          ></datepicker>
          <template v-if="activePeriodTab === 0">
            <div class="new-content-data-item-toggle" @click="isAddCompaniesModalOpened = true">
              <p>
                <strong>{{date|formatDayYear}}</strong>
                - Подобекти за деня ({{calendars.length}})
              </p>
              <span class="new-content-data-item-toggle-circle">
                <span class="sienit2">I</span>
              </span>
            </div>
            <div class="new-content-data-item">
              <div
                class="new-content-data-item-content"
                :class="{ 'new-content-data-item-content-no-results' : !calendars.length}"
              >
                <template v-if="calendars.length">
                  <p
                    v-for="(c, index) in calendars"
                    :key="`object-${index}-addedWorker-${c._id}`"
                  >{{c.object.objectName}}</p>
                </template>
                <p v-else>Няма добавени подобекти за деня</p>
              </div>
            </div>
          </template>
        </div>
        <div class="right-panel" id="rightPanel">
          <!-- OBJECTS CALENDAR -->
          <div class="objects-calendar" v-if="calendars.length">
            <template v-if="activePeriodTab === 0">
              <div
                class="objects-calendar-item"
                :class="{ 'objects-calendar-item-ok' : (c.isReady && c.isConfirmed), 
                  'objects-calendar-item-wait' : (c.isReady && !c.isConfirmed),
                  'objects-calendar-item-send' : (!c.isReady && !c.isConfirmed) }"
                v-for="(c, index) in calendars"
                :key="`${index}-${c.company._id}-${c.project._id}-${c.object._id}`"
                :id="`item-${c._id}`"
              >
                <div class="objects-calendar-item-header">
                  <p>{{c.company.companyName}}</p>
                  <p>{{c.project.projectName}}</p>
                  <p>{{c.object.objectName}}</p>
                </div>
                <div class="objects-calendar-item-content" :class="{ 'objects-calendar-item-content-highlight' : $route.query.id === c._id }">
                  <div
                    class="list-container"
                    @click="openWorkersModal(index, c.isReady)"
                    v-if="c.workers.length"
                  >
                    <div class="sienit2 toggle">Q</div>
                    <header>
                      <p>Изпълнители ({{ c.workers.length }})</p>
                    </header>
                    <div class="list-tag-wrapper">
                      <div
                        v-for="(w, i) in c.workers"
                        :key="`${c.object._id}-${w._id}`"
                        class="list-tag"
                      >
                        <span
                          class="sienit delete-item"
                          v-if="!c.isReady"
                          @click.stop="deleteItem(index, 'workers', i)"
                        >b</span>
                        {{w.name}}
                      </div>
                    </div>
                  </div>
                  <div class="big-toggle-wrapper big-toggle-workers" v-else>
                    <div class="big-toggle" @click="openWorkersModal(index, c.isReady)">
                      <div class="big-toggle-inner">
                        <div class="sienit2">Q</div>
                        <p>
                          Добави
                          <br />изпълнители
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="list-container"
                    @click="openMaterials(index, c.isReady)"
                    v-if="c.materials.length"
                  >
                    <div class="sienit toggle">T</div>
                    <header>
                      <p>Материали ({{ c.materials.length }})</p>
                    </header>
                    <div class="list-tag-wrapper">
                      <div
                        v-for="(m, j) in c.materials"
                        :key="`${c.object._id}-${m._id}-${j}`"
                        class="list-tag"
                      >
                        <span
                          class="sienit delete-item"
                          v-if="!c.isReady"
                          @click.stop="deleteItem(index, 'materials', j)"
                        >b</span>
                        {{m.name}} - {{m.quantity}} {{m.unit}}
                      </div>
                    </div>
                  </div>
                  <div class="big-toggle-wrapper big-toggle-materials" v-else>
                    <div class="big-toggle" @click="openMaterials(index, c.isReady)">
                      <div class="big-toggle-inner">
                        <div class="sienit">T</div>
                        <p>
                          Добави
                          <br />материали
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="list-container"
                    @click="openMechanizations(index, c.isReady)"
                    v-if="c.mechanizations.length"
                  >
                    <div class="sienit2 toggle">Y</div>
                    <header>
                      <p>Механизации ({{ c.mechanizations.length }})</p>
                    </header>
                    <div class="list-tag-wrapper">
                      <div
                        v-for="(m, j) in c.mechanizations"
                        :key="`${c.object._id}-${m._id}-${j}`"
                        class="list-tag"
                      >
                        <span
                          class="sienit delete-item"
                          v-if="!c.isReady"
                          @click.stop="deleteItem(index, 'mechanizations', j)"
                        >b</span>
                        {{m.name}} - {{m.quantity}} {{m.unit}}
                      </div>
                    </div>
                  </div>
                  <div class="big-toggle-wrapper big-toggle-mechanizations" v-else>
                    <div class="big-toggle" @click="openMechanizations(index, c.isReady)">
                      <div class="big-toggle-inner">
                        <div class="sienit2">Y</div>
                        <p>
                          Добави
                          <br />механизации
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="objects-calendar-item-content-add">
                    <div class="add-items-wrapper">
                      <button
                        class="objects-calendar-item-content-add-item"
                        @click="openCopyMoveCalendarModal('copy', c._id)"
                        title="Копиране"
                      >
                        <img src="../assets/img/copy.png" alt="Копирай" />
                      </button>
                      <button
                        class="objects-calendar-item-content-add-item"
                        @click="openCopyMoveCalendarModal('move', c._id)"
                        :disabled="c.isReady"
                        :title="`${ c.isReady ? 'Преместаването не е позволено защото заявката е изпратена за одобрение' : 'Преместване' }`"
                      >
                        <img src="../assets/img/move.png" alt="Премести" />
                      </button>
                      <button
                        class="objects-calendar-item-content-add-item"
                        @click="removeCalendar(c)"
                        :disabled="c.isReady"
                        :title="`${ c.isReady ? 'Изтриването не е позволено защото заявката е изпратена за одобрение' : 'Изтриване' }`"
                      >
                        <img src="../assets/img/delete.png" alt="Изтрий" />
                      </button>
                      <button class="objects-calendar-item-content-add-item">
                        <img
                          src="../assets/img/print.png"
                          @click="print(c._id)"
                          title="Принтиране"
                          alt="Принтиране"
                        />
                      </button>
                      <button
                        class="objects-calendar-item-content-add-item"
                        :title="getInfo(c, false)"
                        @click="displayInfo(c)"
                      >
                        <img src="../assets/img/info.png" alt="Информация" />
                      </button>
                    </div>
                    <div class="add-items-wrapper">
                      <template v-if="c.isReady && !c.isConfirmed ">
                        <button
                          v-if="getUser.permissions.isSuperAdmin"
                          class="objects-calendar-item-content-add-item button-ok"
                          @click="sendConfirm(c)"
                        >
                          <span>ОДОБРИ</span>
                          <img src="../assets/img/ok.png" alt="Изпрати за одобрение" />
                        </button>
                        <button v-else class="objects-calendar-item-content-add-item button-wait">
                          <span>В ИЗЧАКВАНЕ</span>
                        </button>
                      </template>
                      <button
                        v-else-if="!c.isReady && !c.isConfirmed"
                        class="objects-calendar-item-content-add-item button-send"
                        @click="sendForConfirmation(c)"
                      >
                        <span>ИЗПРАТИ</span>
                        <img src="../assets/img/send.png" alt="Изпрати за одобрение" />
                      </button>
                      <button
                        v-if="c.isConfirmed && c.isReady"
                        class="objects-calendar-item-content-add-item button-confirmed"
                      >
                        <span>ОДОБРЕНО</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="activePeriodTab === 1">
              <div class="big-calendar-item" v-for="c in calendars" :key="c._id">
                <div class="date-calendar-item-header">
                  <p>{{c.date | formatDay}}</p>
                  <p class="date-calendar-objects-count">
                    <span class="sienit2">P</span>
                    {{c.calendars.length}}&nbsp;
                    <span
                      v-if="c.calendars.length === 1"
                    >Подобект</span>
                    <span v-else>Подобекта</span>
                  </p>
                </div>
                <div class="big-calendar-item-content">
                  <div class="companies-container">
                    <div
                      v-for="ca in c.calendars"
                      :key="ca._id"
                      class="companies-tag"
                      :class="{ 
                      'companies-tag-send': !ca.isReady && !ca.isConfirmed,
                      'companies-tag-wait': ca.isReady && !ca.isConfirmed,
                      'companies-tag-ok': ca.isReady && ca.isConfirmed
                     }"
                    >
                      <template v-if="ca">
                        <p>{{ca.company.companyName}}</p>
                        <p>{{ca.project.projectName}}</p>
                        <p>{{ca.object.objectName}}</p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="workers-calendar no-results-calendar" v-if="!calendars.length">
            <div class="workers-calendar-item">
              <div class="workers-calendar-item-header">
                <p>Подобекти за деня</p>
              </div>
              <div class="workers-calendar-item-content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <AddUsersModal
        v-if="selectedObject !== undefined"
        :incomingUsers="calendars[selectedObject].workers"
        :usersType="'isWorker'"
      />
    </transition>
    <transition name="fade">
      <AddCompaniesModal v-if="isAddCompaniesModalOpened" />
    </transition>
    <transition name="fade">
      <CopyMoveCalendarModal
        v-if="CopyMoveCalendarModalAction"
        :action="CopyMoveCalendarModalAction"
        :id="CopyMoveCalendarModalCalendar"
      />
    </transition>
    <transition name="fade">
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :isComingFromReport="true"
        :companyId="selectedIds.companyId"
        :projectId="selectedIds.projectId"
        :objectId="selectedIds.objectId"
        :incomingMaterials="selectedObjectMaterials"
      />
    </transition>
    <transition name="fade">
      <AddMechanizationsModal
        v-if="isAddMechanizationsModalOpened"
        :isComingFromReport="true"
        :companyId="selectedIds.companyId"
        :projectId="selectedIds.projectId"
        :objectId="selectedIds.objectId"
        :incomingMechanizations="selectedObjectMechanizations"
      />
    </transition>
    <transition name="fade">
      <AddQuantityModal v-if="addQuantityTo" :val="addQuantityTo" />
    </transition>
  </div>
</template>

<script>
// import print from 'print-js';
import AddUsersModal from './shared/AddUsersModal';
import AddCompaniesModal from './shared/AddCompaniesModal';
import CopyMoveCalendarModal from './shared/CopyMoveCalendarModal';
import AddMaterialsModal from './shared/AddMaterialsModal';
import AddMechanizationsModal from './shared/AddMechanizationsModal';
import AddQuantityModal from './shared/AddQuantityModal';
import Datepicker from 'vuejs-datepicker';
import { bg } from 'vuejs-datepicker/dist/locale';
import { mapGetters } from 'vuex';
import log from './mixins/log.js';
export default {
  components: {
    Datepicker: Datepicker,
    AddUsersModal: AddUsersModal,
    AddCompaniesModal: AddCompaniesModal,
    CopyMoveCalendarModal: CopyMoveCalendarModal,
    AddMaterialsModal: AddMaterialsModal,
    AddMechanizationsModal: AddMechanizationsModal,
    AddQuantityModal: AddQuantityModal
  },
  mixins: [log],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser'
      // ...
    ])
  },
  data() {
    return {
      bg: bg,
      months: [
        'Януари',
        'Февруари',
        'Март',
        'Април',
        'Май',
        'Юни',
        'Юли',
        'Август',
        'Септември',
        'Октомври',
        'Ноември',
        'Декември'
      ],
      highlightedDates: [],
      highlighted: { to: '', from: '' },
      date: '',
      firstDay: undefined,
      lastDay: undefined,
      format: 'MMMM yyyy',
      activePeriodTab: 0,
      calendars: [],
      workers: [],
      isAddCompaniesModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddMechanizationsModalOpened: false,
      selectedObject: undefined,
      CopyMoveCalendarModalAction: '',
      CopyMoveCalendarModalCalendar: undefined,
      showMobileDatepicker: false,
      selectedObjectMaterials: [],
      selectedObjectMechanizations: [],
      selectedIds: {
        companyId: null,
        projectId: null,
        objectId: null,
        objectIndex: null,
        type: null
      },
      addQuantityTo: null
    };
  },
  watch: {
    date() {
      this.showMobileDatepicker = false;
      this.getCalendars();
      this.firstDay = new Date(this.date).GetFirstDayOfWeek();
      this.lastDay = new Date(this.date).GetLastDayOfWeek();
      if (this.activePeriodTab === 1) {
        this.highlighted = { from: this.firstDay, to: this.lastDay };
      } else {
        this.highlighted = {
          dates: this.highlightedDates
        };
      }
    }
  },
  methods: {
    changePeriodTab(n) {
      this.showMobileDatepicker = false;
      this.firstDay = new Date(this.date).GetFirstDayOfWeek();
      this.lastDay = new Date(this.date).GetLastDayOfWeek();
      this.calendars = [];
      this.activePeriodTab = n;
      if (this.activePeriodTab === 1) {
        this.highlighted = { from: this.firstDay, to: this.lastDay };
      } else {
        this.highlighted = {
          dates: this.highlightedDates
        };
      }
      this.getCalendars();
    },
    handleCompanies(c) {
      const url = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/exists/${this.date.toISOString()}/${c.companyId}/${
        c.projectId
      }/${c.objectId}`;
      this.$http.get(url).then(response => {
        if (!response.data.length) {
          const calendar = {
            date: this.date,
            createdAt: new Date(),
            createdBy: this.getUser._id,
            companyId: c.companyId,
            projectId: c.projectId,
            objectId: c.objectId,
            isReady: false,
            isConfirmed: false
          };
          const url = `${process.env.VUE_APP_BASE_URI}/calendar`;
          this.$http
            .post(url, calendar)
            .then(a => {
              if (a.data.errors) {
                console.log(a.data.errors);
                this.$snotify.error(`Нещо се обърка`);
              } else {
                const dateString = `${this.date.getDate()} ${
                  this.months[this.date.getMonth()]
                } ${this.date.getFullYear()}`;
                this.$snotify.success(`Успешно добавен подобект за ${dateString}`);
                this.getCalendars();
                this.closeAddCompaniesModal();
                if (calendar.objectId) {
                  let url = `${process.env.VUE_APP_BASE_URI}/company/object-name/${calendar.objectId}`;
                  return this.$http
                    .get(url)
                    .then(response => {
                      if (response.data) {
                        this.newLog(
                          'newCalendar',
                          `подобект ${response.data[0].objectName} - дата ${dateString}`
                        );
                      }
                    })
                    .catch(error => console.log(error));
                }
              }
            })
            .catch(error => {
              console.log(error.response);
              this.$snotify.error(`Нещо се обърка`);
            });
        } else {
          this.$snotify.error(
            `Този подобект е вече добавен за ${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`
          );
        }
      });
    },
    openWorkersModal(i, isReady) {
      if (!isReady) {
        this.selectedObject = i;
      } else {
        this.$snotify.error(
          'Не може да добавяте повече изпълнители защото заявката е изпратена за одобрение.'
        );
      }
    },
    // If we get the 'saveWorkersModal' event, we assign the workers we receive to the report
    handleWorkers(workers) {
      const workersArray = [];

      workers.forEach(w => {
        workersArray.push({
          _id: w._id
        });
      });

      const newCalendar = this.calendars[this.selectedObject];
      newCalendar.workers = workersArray;

      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${newCalendar._id}`;

      this.$http
        .put(url, newCalendar)
        .then(a => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(`Нещо се обърка`);
          } else {
            this.$snotify.success(`Успешно обновяване на работници.`);
            this.getCalendars();
            this.closeAddWorkersModal();
          }
        })
        .catch(error => {
          console.log(error.response);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    openMaterials(index, isReady) {
      if (!isReady) {
        this.selectedIds = {
          companyId: this.calendars[index].company._id,
          projectId: this.calendars[index].project._id,
          objectId: this.calendars[index].object._id,
          objectIndex: index,
          type: 'materials'
        };
        this.isAddMaterialsModalOpened = true;
        this.getMaterials();
      } else {
        this.$snotify.error(
          'Не може да добавяте повече материали защото заявката е изпратена за одобрение.'
        );
      }
    },
    getMaterials() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/object/${this.selectedIds.objectId}`;
      return this.$http
        .get(url)
        .then(response => {
          this.selectedObjectMaterials = response.data[0].materials;
        })
        .catch(error => console.log(error));
    },
    handleMaterial(m) {
      this.addQuantityTo = m;
    },
    closeAddMaterialsModal() {
      this.resetSelectedIds();
      this.selectedObjectMaterials = [];
      this.isAddMaterialsModalOpened = false;
    },
    openMechanizations(index, isReady) {
      if (!isReady) {
        this.selectedIds = {
          companyId: this.calendars[index].company._id,
          projectId: this.calendars[index].project._id,
          objectId: this.calendars[index].object._id,
          objectIndex: index,
          type: 'mechanizations'
        };
        this.isAddMechanizationsModalOpened = true;
        this.getMechanizations();
      } else {
        this.$snotify.error(
          'Не може да добавяте повече механизации защото заявката е изпратена за одобрение.'
        );
      }
    },
    getMechanizations() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/object/${this.selectedIds.objectId}`;
      return this.$http
        .get(url)
        .then(response => {
          this.selectedObjectMechanizations = response.data[0].mechanizations;
        })
        .catch(error => console.log(error));
    },
    handleMechanization(m) {
      this.addQuantityTo = m;
    },
    closeAddMechanizationsModal() {
      this.resetSelectedIds();
      this.selectedObjectMechanizations = [];
      this.isAddMechanizationsModalOpened = false;
    },
    resetSelectedIds() {
      this.selectedIds = {
        companyId: null,
        projectId: null,
        objectId: null,
        objectIndex: null,
        type: null
      };
    },
    handleUpdate(x) {
      const newCalendar = this.calendars[this.selectedIds.objectIndex];
      newCalendar[this.selectedIds.type].push(x.value);
      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${newCalendar._id}`;
      this.$http
        .put(url, newCalendar)
        .then(a => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(`Нещо се обърка`);
          } else {
            this.$snotify.success(`Успешно добавен/а материал/механизация.`);
            this.getCalendars();
            this.closeAddQuantityModal();
            this.resetSelectedIds();
            this.closeAddMaterialsModal();
            this.closeAddMechanizationsModal();
          }
        })
        .catch(error => {
          console.log(error.response);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    closeAddQuantityModal() {
      this.addQuantityTo = null;
    },
    // If we get the 'saveWorkersModal' event, we assign the workers we receive to the report
    deleteItem(selected, type, i) {
      const newCalendar = this.calendars[selected];
      newCalendar[type].splice(i, 1);

      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${newCalendar._id}`;

      this.$http
        .put(url, newCalendar)
        .then(a => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(`Нещо се обърка`);
          } else {
            this.$snotify.success(`Успешно изтриване`);
            this.getCalendars();
            this.closeAddWorkersModal();
          }
        })
        .catch(error => {
          console.log(error.response);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    getCalendars() {
      this.$store.dispatch('startLoading');

      let type = '';

      // DAILY
      let firstDate = this.date;
      let secondDate = this.date;
      // WHOLE WEEK
      if (this.activePeriodTab === 1) {
        firstDate = new Date(this.date).GetFirstDayOfWeek();
        secondDate = new Date(this.date).GetLastDayOfWeek();
      }

      type = 'day';

      let requestUrl = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/${type}/${this.date.toISOString()}`;

      // BUILD THE REQUEST URL FOR ALL CALENDARS
      if (this.activePeriodTab === 0) {
        requestUrl = `${
          process.env.VUE_APP_BASE_URI
        }/calendar/${type}/${firstDate.toISOString()}`;
      }
      // WEEK
      else if (this.activePeriodTab === 1) {
        requestUrl = `${
          process.env.VUE_APP_BASE_URI
        }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}`;
      }

      this.$http
        .get(requestUrl)
        .then(response => {
          this.$store.dispatch('stopLoading');
          this.calendars = response.data;
        })
        .catch(error => console.log(error));
    },
    openCopyMoveCalendarModal(type, c) {
      this.CopyMoveCalendarModalAction = type;
      this.CopyMoveCalendarModalCalendar = c;
    },
    closeCopyMoveCalendarModal(e) {
      this.CopyMoveCalendarModalAction = '';
      this.CopyMoveCalendarModalCalendar = undefined;
      if (e.updated) {
        this.getCalendars();
      }
    },
    removeCalendar(c) {
      if (c._id) {
        let url = `${process.env.VUE_APP_BASE_URI}/calendar/${c._id}`;
        this.$http
          .delete(url)
          .then(result => {
            if (result.data.errors) {
              this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
              console.log(result);
            } else {
              this.$snotify.success(`Успешно изтрит подобект.`);
              this.getCalendars();
              if (result.data.calendar.objectId) {
                let url = `${process.env.VUE_APP_BASE_URI}/company/object-name/${result.data.calendar.objectId}`;
                return this.$http
                  .get(url)
                  .then(response => {
                    if (response.data) {
                      let dateString = new Date(result.data.calendar.date);
                      dateString = `${dateString.getDate()} ${
                        this.months[dateString.getMonth()]
                      } ${dateString.getFullYear()}`;
                      this.newLog(
                        'deleteCalendar',
                        `подобект ${response.data[0].objectName} - дата ${dateString}`
                      );
                    }
                  })
                  .catch(error => console.log(error));
              }
            }
          })
          .catch(error => {
            console.log(error);
            this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
          });
      }
    },
    // Close the workers modal
    closeAddCompaniesModal() {
      this.isAddCompaniesModalOpened = false;
    },
    closeAddWorkersModal() {
      this.selectedObject = undefined;
    },
    print() {
      this.$snotify.warning(
        'В момента функционалността се разработва и ще бъде активна скоро.'
      );
    },
    getInfo(c, short) {
      let output = `Създадено на ${
        short
          ? this.$options.filters.formatDate(c.createdAt)
          : this.$options.filters.formatFullDate(c.createdAt)
      } от ${c.createdBy.name}${short ? '' : ` (${c.createdBy.username})`}.`;

      if (c.isReady) {
        output += ` Изпратено за одобрение на ${
          short
            ? this.$options.filters.formatDate(c.readyAt)
            : this.$options.filters.formatFullDate(c.readyAt)
        } от ${c.readyBy.name}${short ? '' : ` (${c.readyBy.username})`}.`;
      }

      if (c.isConfirmed) {
        output += ` Oдобренo на ${
          short
            ? this.$options.filters.formatDate(c.confirmedAt)
            : this.$options.filters.formatFullDate(c.confirmedAt)
        } от ${c.confirmedBy.name}${
          short ? '' : ` (${c.confirmedBy.username})`
        }.`;
      }

      return output;
    },
    displayInfo(c) {
      this.$snotify.info(this.getInfo(c, true));
    },
    sendForConfirmation(c) {
      if (!c.isReady) {
        if (
          !c.materials.length &&
          !c.workers.length &&
          !c.mechanizations.length
        ) {
          this.$snotify.error(
            'Трябва да добавите поне един изпълнител, материал или механизация!'
          );
          return;
        }

        if (
          confirm(
            'Сигурни ли сте, че искате да изпратите заявката за одобрение?'
          )
        ) {
          const newCalendar = c;
          newCalendar.isReady = true;
          newCalendar.readyBy = this.getUser._id;
          newCalendar.readyAt = new Date();

          this.updateCalendar(
            newCalendar,
            'Заявката е изпратена за одобрение!',
            'readyCalendar'
          );
        }
      }
    },
    sendConfirm(c) {
      if (c.isReady) {
        if (confirm('Сигурни ли сте, че искате да одобрите заявката?')) {
          const newCalendar = c;
          newCalendar.isConfirmed = true;
          newCalendar.confirmedBy = this.getUser._id;
          newCalendar.confirmedAt = new Date();

          this.updateCalendar(
            newCalendar,
            'Заявката е одобрена!',
            'confirmCalendar'
          );
        }
      }
    },
    updateCalendar(c, message, log) {
      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${c._id}`;
      this.$http
        .put(url, c)
        .then(a => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(`Нещо се обърка`);
          } else {
            this.$snotify.success(message);
            const dateString = `${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`;
            this.newLog(
              log,
              `подобект ${c.object.objectName} - дата ${dateString}`
            );
            this.getCalendars();
          }
        })
        .catch(error => {
          console.log(error.response);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    getHighlighted() {
      const requestUrl = `${process.env.VUE_APP_BASE_URI}/calendar/highlighted`;

      this.$http
        .get(requestUrl)
        .then(response => {
          response.data.dates.map(d => {
            this.highlightedDates.push(new Date(d));
          });
          this.highlighted = {
            dates: this.highlightedDates
          };
        })
        .catch(error => console.log(error));
    },
    scrollH(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      document.getElementById('rightPanel').scrollLeft -= delta * 40;
      e.preventDefault();
    }
  },
  mounted() {
    if (this.$route.query.date) {
      this.date = new Date(this.$route.query.date);
    } else {
      const todayCell = document.getElementsByClassName('today')[0];
      if (todayCell) {
        todayCell.click();
      } else {
        this.date = new Date();
      }
    }

    this.getCalendars();
    this.getHighlighted();

    this.$on('mousewheel', this.scrollH, false);
    // Start listening for children's events
    this.$on('saveAddCompaniesModal', this.handleCompanies);
    this.$on('saveAddUsersModal', this.handleWorkers);
    this.$on('saveAddMaterialsModal', this.handleMaterial);
    this.$on('saveAddMechanizationsModal', this.handleMechanization);
    this.$on('getMaterialsAgain', this.getMaterials);
    this.$on('getMechanizationsAgain', this.getMechanizations);
    this.$on('addQuantity', this.handleUpdate);
    // Close listening for children's events
    this.$on('closeAddCompaniesModal', this.closeAddCompaniesModal);
    this.$on('closeAddUsersModal', this.closeAddWorkersModal);
    this.$on('closeAddMaterialsModal', this.closeAddMaterialsModal);
    this.$on('closeAddMechanizationsModal', this.closeAddMechanizationsModal);
    this.$on('closeCopyMoveCalendarModal', this.closeCopyMoveCalendarModal);
    this.$on('closeAddQuantityModal', this.closeAddQuantityModal);
  },
  destroyed() {
    // Stop listening
    this.$off('mousewheel');
    this.$off('saveAddCompaniesModal');
    this.$off('saveAddUsersModal');
    this.$off('saveAddMaterialsModal');
    this.$off('saveAddMechanizationsModal');
    this.$off('addQuantity');
    this.$off('getMaterialsAgain');
    this.$off('getMechanizationsAgain');
    this.$off('closeAddCompaniesModal');
    this.$off('closeAddUsersModal');
    this.$off('closeAddMaterialsModal');
    this.$off('closeAddMechanizationsModal');
    this.$off('closeCopyMoveCalendarModal');
    this.$off('closeAddQuantityModal');
  }
};
</script>

<style scoped>
/* IT WILL BE A GOOD IDEA TO REFACTOR THE WHOLE CSS  */
label {
  color: #373737;
  font-size: 11px;
  font-weight: 700;
}
.week {
  background-color: #f0f0f7;
  border: 0;
  text-align: center;
  width: 300px;
}
.calendar-wrapper {
  display: flex;
}
.calendar {
  background-color: #fff;
  padding: 10px 40px;
  transition: all 0.3s;
  width: 100%;
}
.calendar-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.calendar-header h2 {
  color: #373737;
  font-size: 20px;
}
.calendar-header-left {
  align-items: center;
  display: flex;
  justify-content: space-between;
  /* width: 300px; */
}
.calendar-header-left label {
  margin-right: 10px;
  white-space: nowrap;
}
.calendar-content {
  background-color: #fbfaf5;
  border: 1px solid #f4eaea;
  border-radius: 4px;
  display: flex;
  margin-top: 10px;
  min-height: calc(100vh - 166px);
  /* max-height: calc(100vh - 166px); */
  padding: 12px 15px;
}
.left-panel {
  display: flex;
  border-right: 1px solid rgba(234, 240, 244, 0.5);
  flex-direction: column;
  margin-right: 10px;
  padding-right: 10px;
  min-width: 22vw;
  width: 22vw;
}
.left-panel-header {
  align-items: center;
  display: flex;
  height: 45px;
  min-height: 45px;
  justify-content: space-between;
  padding-bottom: 10px;
}
.views {
  display: flex;
  width: 100%;
}

.view {
  background-color: #f5f5f5;
  border: 1px solid #d7dae2;
  color: #4d4f5c;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  height: 35px;
  min-width: 80px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 33.33%;
}
.view:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.view:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.view-active {
  background-color: #8d3506;
  border: 1px solid #8d3506;
  color: #ffffff;
}
.view:hover {
  background-color: #f9f9f9;
}
.view-active:hover {
  background-color: #a7430e;
}
.new-content-data-item {
  border: 1px solid #f4eaea;
  height: 100%;
  overflow: auto;
  position: relative;
  /* max-height: 50vh; */
  width: 100%;
}
.new-content-data-item-toggle {
  background-color: #ece9d8;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 11px;
  height: 36px;
  min-height: 36px;
  margin-top: 10px;
  width: 100%;
  -webkit-transition: none;
  -moz-transition: none;
  -ms-transition: none;
  -o-transition: none;
  transition: none;
  z-index: 1;
}
.new-content-data-item-toggle:hover {
  background-color: #d8d2bd;
}
.new-content-data-item-toggle .new-content-data-item-toggle-circle {
  position: absolute;
  right: 10px;
  top: 6px;
}
.add-wrapper {
  width: 100%;
}
.add {
  align-items: center;
  background-color: #3b86ff;
  border: 0;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  font-size: 11px;
  height: 50px;
  justify-content: space-between;
  /* font-weight: 700; */
  padding: 0 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.add:hover {
  background-color: #5193fd;
}
.add-wrapper span.new-content-data-item-toggle-circle {
  background-color: #ffffff;
  font-size: 16px;
  color: #0078d7;
}
.add-wrapper .new-content-data-item-toggle-circle .sienit2 {
  background-color: #ffffff;
  border-color: #ffffff;
}
.add-wrapper:hover .new-content-data-item-toggle-circle .sienit2 {
  border-color: #3b86ff;
}
.right-panel {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
}
.selected-date {
  font-size: 18px;
  padding: 7px 0;
}
.overtime {
  background-color: rgba(252, 252, 229, 0.63);
  border: 1px solid #eaf0f4;
  transform: rotate(270deg);
}
.normal {
  background-color: rgba(232, 245, 233, 0.37);
  border: 1px solid #eaf0f4;
  transform: rotate(270deg);
}
/* WORKERS */
.workers-calendar,
.objects-calendar,
.big-calendar {
  display: flex;
  height: 100%;
}
.workers-calendar-item,
.objects-calendar-item,
.big-calendar-item {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  min-width: 400px;
  width: 400px;
}
.workers-calendar-item-header,
.objects-calendar-item-header,
.date-calendar-item-header {
  align-items: center;
  background-color: #ece9d8;
  border: 1px solid #f4eaea;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 6px;
  max-height: 65px;
  min-height: 65px;
  padding: 10px 0;
  position: relative;
  width: 100%;
}
.workers-calendar-item-header {
  max-height: 35px;
  min-height: 35px;
}
.workers-calendar-item-header p,
.objects-calendar-item-header p,
.date-calendar-item-header p {
  color: #8d3506;
  font-size: 9px;
  font-weight: 400;
  text-align: center;
}
.workers-calendar-item-header p:nth-child(3),
.objects-calendar-item-header p:nth-child(3),
.date-calendar-item-header p:nth-child(3) {
  font-size: 12px;
  font-weight: 700;
}
.workers-calendar-item-content,
.objects-calendar-item-content,
.big-calendar-item-content {
  align-items: center;
  background-color: #fff;
  border: 1px solid #f4eaea;
  border-radius: 4px;
  flex-direction: column;
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  padding: 5px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  position: relative;
  width: 400px;
}
.objects-calendar-item-content-highlight {
  background-color: #fff1dc;
}

/* .workers-calendar-item-content:hover,
.objects-calendar-item-content:hover,
.big-calendar-item-content:hover {
  background-color: #fff;
} */
.new-content-data-item-content {
  display: flex;
  flex-direction: column;
}
.new-content-data-item-content-no-results {
  height: 100%;
  justify-content: center;
  align-items: center;
}
.new-content-data-item-content p {
  color: #737373;
  font-size: 11px;
  padding: 5px;
}
.add-items-wrapper {
  display: flex;
  align-items: center;
}
.add-items-wrapper:last-child {
  width: 100%;
}
.workers-calendar-item-content-add,
.objects-calendar-item-content-add,
.big-calendar-item-content-add {
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 40px;
  /* padding: 4px; */
  width: 100%;
}

.objects-calendar-item-content-add-item {
  align-items: center;
  background-color: rgba(121, 119, 116, 0.15);
  border-radius: 4px;
  border: 1px solid transparent;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  height: 40px;
  margin-right: 7px;
  justify-content: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 40px;
}
.add-items-wrapper:last-child .objects-calendar-item-content-add-item {
  border: none;
  color: #fff;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 0;
  padding: 0 6px;
  width: 100%;
}
.add-items-wrapper:last-child .objects-calendar-item-content-add-item:hover {
  border: none;
  opacity: 0.8;
}
.button-send {
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#6191d8+0,066894+100 */
  background: rgb(97, 145, 216); /* Old browsers */
  background: -moz-linear-gradient(
    top,
    rgba(97, 145, 216, 1) 0%,
    rgba(6, 104, 148, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(97, 145, 216, 1) 0%,
    rgba(6, 104, 148, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(97, 145, 216, 1) 0%,
    rgba(6, 104, 148, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#6191d8', endColorstr='#066894',GradientType=0 ); /* IE6-9 */
}
.add-items-wrapper:last-child
  .objects-calendar-item-content-add-item.button-wait,
.add-items-wrapper:last-child
  .objects-calendar-item-content-add-item.button-wait:hover {
  background-color: #fdeada;
  cursor: default;
  justify-content: center;
  opacity: 1;
}
.button-wait span {
  color: #8d3506;
}
.add-items-wrapper:last-child
  .objects-calendar-item-content-add-item.button-confirmed,
.add-items-wrapper:last-child
  .objects-calendar-item-content-add-item.button-confirmed:hover {
  background-color: #e2efd9;
  cursor: default;
  justify-content: center;
  opacity: 1;
}
.button-confirmed span {
  color: #055514;
}
.button-ok {
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#068d33+0,3c4a00+100 */
  background: rgb(6, 141, 51); /* Old browsers */
  background: -moz-linear-gradient(
    top,
    rgba(6, 141, 51, 1) 0%,
    rgba(60, 74, 0, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(6, 141, 51, 1) 0%,
    rgba(60, 74, 0, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(6, 141, 51, 1) 0%,
    rgba(60, 74, 0, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#068d33', endColorstr='#3c4a00',GradientType=0 ); /* IE6-9 */
}
.objects-calendar-item-content-add-item:disabled {
  cursor: default;
  opacity: 0.5;
}
/* .objects-calendar-item-content-add-item:last-child {
  margin-right: 0;
} */
.objects-calendar-item-content-add-item-big {
  height: 100%;
  width: 100%;
}
.objects-calendar-item-content-add-item:hover:not(:disabled) {
  background-color: #fff;
  border-color: #d8d2bd;
}
.objects-calendar-item-content-add-item-big:hover {
  background: rgba(237, 241, 245, 0.8);
}
.workers-calendar-item-content-add-item .sienit,
.workers-calendar-item-content-add-item .sienit2,
.objects-calendar-item-content-add-item .sienit,
.objects-calendar-item-content-add-item .sienit2,
.big-calendar-item-content-add-item .sienit,
.big-calendar-item-content-add-item .sienit2 {
  align-items: center;
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 16px;
  flex-direction: column;
  height: 34px;
  justify-content: center;
  position: relative;
  width: 34px;
}
.workers-calendar-item-content-add-item .sienit::after,
.workers-calendar-item-content-add-item .sienit2::after,
.objects-calendar-item-content-add-item .sienit::after,
.objects-calendar-item-content-add-item .sienit2::after,
.big-calendar-item-content-add-item .sienit::after,
.big-calendar-item-content-add-item .sienit2::after {
  content: '';
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 50%;
  height: 30px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 30px;
}
.workers-calendar-item-content:hover .workers-calendar-item-content-add-hidden,
.big-calendar-item-content:hover .big-calendar-item-content-add-hidden {
  background-color: rgba(237, 241, 245, 0.8);
  opacity: 1;
}
.workers-calendar-item-content-add-item:hover .sienit::after,
.workers-calendar-item-content-add-item:hover .sienit2::after,
.objects-calendar-item-content-add-item:hover .sienit::after,
.objects-calendar-item-content-add-item:hover .sienit2::after,
.big-calendar-item-content-add-item:hover .sienit::after,
.big-calendar-item-content-add-item:hover .sienit2::after {
  border: 1px solid #fff;
}
.workers-calendar-item-content-add p,
.objects-calendar-item-content-add p,
.big-calendar-item-content-add p {
  font-size: 10px;
  text-align: center;
}
.no-results-calendar {
  width: 100%;
}
.no-results-calendar .workers-calendar-item {
  width: 100%;
}
.no-results-calendar .workers-calendar-item-content {
  background: #fff;
  cursor: default;
  width: 100%;
}
/* .no-results-calendar .workers-calendar-item-content:hover {
  background-color: transparent;
} */
.companies-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  justify-content: center;
  width: 100%;
}
.companies-tag,
.personal-tag {
  align-items: center;
  background-color: #ece9d8;
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 5px;
  margin-bottom: 5px;
  min-height: 180px;
  width: 100%;
}
.companies-tag-send {
  background-color: #dbe5f1;
}
.companies-tag-wait {
  background-color: #fdeada;
}
.companies-tag-ok {
  background-color: #e2efd9;
}
.personal-tag {
  background-color: #bbdefb;
}
.companies-tag:last-child,
.personal-tag:last-child {
  margin-bottom: 0;
}
.companies-tag p,
.personal-tag p {
  font-size: 10px;
  line-height: 12px;
  opacity: 0.5;
  margin: 3px 0;
  text-align: center;
}
.companies-tag p:nth-child(3),
.personal-tag p:nth-child(3) {
  font-size: 16px;
  line-height: 20px;
  margin: 5px 0 0;
  text-align: center;
  opacity: 1;
}
.list-container,
.big-toggle-wrapper {
  background-color: #ece9d8;
  border: 1px solid #f4eaea;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 33.33%;
  max-height: 25vh;
  margin-bottom: 4px;
  padding-bottom: 10px;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  /* justify-content: center; */
  width: 100%;
}
.big-toggle-wrapper {
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: default;
  flex-direction: row;
  justify-content: center;
  position: relative;
  padding: 0;
}
/* .list-container:hover {
  background-color: rgba(255, 255, 255, 0.8);
} */
.big-toggle-workers {
  align-items: flex-end;
  padding-bottom: 10px;
}
.big-toggle-mechanizations {
  align-items: flex-start;
  padding-top: 10px;
}
.big-toggle {
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  height: 124px;
  border: 1px dashed #e0d0c1;
  padding: 3px;
  width: 124px;
}
.big-toggle-inner {
  background-color: #ece9d8;
  border-radius: 50%;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}

.big-toggle-workers .big-toggle-inner {
  background-color: #d9ecd8;
}

.big-toggle-workers .big-toggle:hover .big-toggle-inner {
  background-color: #9cd299;
}

.big-toggle-materials .big-toggle-inner {
  background-color: #d8ddec;
}
.big-toggle-materials .big-toggle:hover .big-toggle-inner {
  background-color: #9cabd6;
}

.big-toggle-mechanizations .big-toggle-inner {
  background-color: #ecddd8;
}

.big-toggle-mechanizations .big-toggle:hover .big-toggle-inner {
  background-color: #dcbbb0;
}

.big-toggle-inner .sienit,
.big-toggle-inner .sienit2 {
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  color: #8d3506;
  display: flex;
  font-size: 16px;
  height: 32px;
  justify-content: center;
  margin-bottom: 6px;
  width: 32px;
}
.big-toggle-inner p {
  color: #000;
  font-size: 11px;
  font-weight: 700;
  line-height: 12px;
  text-align: center;
}
.list-container header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
}
.list-container header p {
  color: #8d3506;
  font-size: 12px;
  font-weight: 700;
}
.list-container .toggle {
  align-items: center;
  background-color: #8d3506;
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 34px;
  justify-content: center;
  position: absolute;
  right: 5px;
  top: 5px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 34px;
}
.list-tag-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.list-tag-wrapper::-webkit-scrollbar {
  width: 1px;
}

.list-tag-wrapper::-webkit-scrollbar-track {
  background: #ddd;
}

.list-tag-wrapper::-webkit-scrollbar-thumb {
  background: #8d3506;
}

.list-tag {
  align-items: center;
  color: #8d3506;
  font-size: 10px;
  display: flex;
  /* margin: 2px 0; */
  padding: 5px 10px;
  /* justify-content: center; */
  width: 100%;
}
.delete-item {
  cursor: pointer;
  font-size: 12px;
  margin-right: 4px;
}
.delete-item:hover {
  opacity: 0.8;
}
.date-calendar-item-header .date-calendar-objects-count {
  align-items: center;
  background-color: #8d3506;
  border-radius: 15px;
  color: #fff;
  opacity: 1;
  font-weight: 400;
  display: flex;
  justify-content: center;
  margin-top: 5px;
  padding: 7px;
  width: 90%;
}
.date-calendar-item-header .date-calendar-objects-count .sienit2 {
  font-size: 14px;
  font-weight: 400;
  margin-right: 5px;
}
.big-calendar-count-toggle {
  align-items: center;
  background-color: #104d80;
  border-radius: 30px;
  color: #fff;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  position: relative;
  padding: 5px 10px;
}
.big-calendar-count-toggle span {
  font-size: 14px;
}
.big-calendar-count-toggle .sienit2 {
  font-size: 20px;
  margin-right: 5px;
}
.company {
  align-items: start;
  padding: 4px;
}
.btn {
  margin: 0;
}

/* OK */
.objects-calendar-item-send .objects-calendar-item-header {
  background-color: #b8cce4;
}
.objects-calendar-item-send .list-container {
  background-color: #dbe5f1;
}
.objects-calendar-item-send .objects-calendar-item-header p,
.objects-calendar-item-send .list-container .list-tag,
.objects-calendar-item-send .list-container header p {
  color: #1f497d;
}
.objects-calendar-item-send .list-container .sienit.toggle,
.objects-calendar-item-send .list-container .sienit2.toggle {
  background-color: #1f497d;
}
.objects-calendar-item-send .list-tag-wrapper::-webkit-scrollbar-thumb {
  background: #1f497d;
}

/* OK */
.objects-calendar-item-ok .objects-calendar-item-header {
  background-color: #c5e0b3;
}
.objects-calendar-item-ok .list-container {
  background-color: #e2efd9;
}
.objects-calendar-item-ok .objects-calendar-item-header p,
.objects-calendar-item-ok .list-container .list-tag,
.objects-calendar-item-ok .list-container header p {
  color: #055514;
}
.objects-calendar-item-ok .list-container .sienit.toggle,
.objects-calendar-item-ok .list-container .sienit2.toggle {
  background-color: #055514;
}
.objects-calendar-item-ok .list-tag-wrapper::-webkit-scrollbar-thumb {
  background: #055514;
}

/* WAIT */
.objects-calendar-item-wait .objects-calendar-item-header {
  background-color: #fbd5b5;
}
.objects-calendar-item-wait .list-container {
  background-color: #fdeada;
}
.objects-calendar-item-wait .objects-calendar-item-header p,
.objects-calendar-item-wait .list-container .list-tag,
.objects-calendar-item-wait .list-container header p {
  color: #8d3506;
}
.objects-calendar-item-wait .list-container .sienit.toggle,
.objects-calendar-item-wait .list-container .sienit2.toggle {
  background-color: #8d3506;
}
.objects-calendar-item-wait .list-tag-wrapper::-webkit-scrollbar-thumb {
  background: #8d3506;
}
/* * */
/* PERSONAL */
/* * */
.personal-calendar {
  display: block;
}
.personal-calendar .big-calendar-item {
  width: 100%;
}
.personal-calendar .big-calendar-item-content {
  width: 100%;
}
.personal-calendar .personal-tag {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  min-height: 150px;
  padding: 20px 10px;
}
.personal-calendar .personal-tag .left {
  border-right: 1px solid #104d80;
  margin-right: 50px;
  padding: 0 8px;
  position: relative;
  width: 50%;
}
.personal-calendar .personal-tag .left p {
  text-align: right;
}
.personal-calendar .personal-tag .right {
  border-left: 1px solid #104d80;
  margin-left: 50px;
  padding: 0 10px;
  position: relative;
  width: 50%;
}
.personal-calendar .personal-tag .right p {
  color: #104d80;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  opacity: 1;
  text-align: left;
}
.personal-calendar .personal-tag .left::before,
.personal-calendar .personal-tag .right::before {
  color: #104d80;
  content: 'P';
  font-family: 'sienit2';
  font-size: 20px;
  position: absolute;
  top: 0;
}
.personal-calendar .personal-tag ::before {
  right: -30px;
}
.personal-calendar .personal-tag .right::before {
  content: 'Q';
  left: -30px;
}
.mobile-inline {
  display: none;
}
.mobile-datepicker {
  display: none;
}
@media screen and (max-width: 1440px) {
  .left-panel {
    min-width: 25vw;
    width: 25vw;
  }
}
@media screen and (max-width: 1366px) {
  .left-panel {
    min-width: 28vw;
    width: 28vw;
  }
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile-inline {
    display: inline;
  }
  .calendar {
    padding: 10px 15px;
  }
  .calendar-header {
    position: relative;
  }
  .mobile-datepicker {
    display: inline-flex;
    position: relative;
    width: 100%;
  }
  .mobile-datepicker-toggle {
    align-items: center;
    background-color: #f5f5f5;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    cursor: pointer;
    display: inline-flex;
    justify-content: space-between;
    height: 35px;
    padding: 0 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }
  .mobile-datepicker-toggle:hover {
    background-color: #f9f9f9;
  }
  .mobile-datepicker-toggle span {
    font-size: 12px;
  }
  .mobile-datepicker-toggle .sienit {
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }
  .mobile-datepicker-toggle .rotate-arrow {
    transform: scale(-1);
  }
  .mobile-datepicker-wrapper {
    position: absolute;
    /* height: 100%; */
    /* left: 50%; */
    top: calc(100% + 10px);
    /* width: 100%; */
    z-index: 1;
  }
  .calendar-header-left {
    margin-left: 10px;
  }
  .no-results-calendar-p {
    font-size: 12px;
    text-align: center;
  }
}
@media screen and (max-width: 600px) {
  .mobile-datepicker {
    position: initial;
  }
  .view {
    min-width: 40px;
  }
  .personal-calendar .personal-tag {
    justify-content: center;
    flex-direction: column;
  }
  .personal-calendar .personal-tag .left,
  .personal-calendar .personal-tag .right {
    border-left: 1px solid #104d89;
    border-right: none;
    margin: 0 0 0 35px;
    width: calc(100% - 35px);
  }
  .personal-calendar .personal-tag .left {
    margin-bottom: 10px;
  }
  .personal-calendar .personal-tag .left p,
  .personal-calendar .personal-tag .right p {
    text-align: left;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    right: initial;
    left: -30px;
  }
  .companies-tag p,
  .personal-tag p {
    font-size: 9px;
    margin: 0;
  }
  .companies-tag p:nth-child(3),
  .personal-tag p:nth-child(3) {
    font-size: 13px;
    margin: 0;
  }
  .personal-calendar .personal-tag .right p {
    font-size: 11px;
    line-height: 14px;
  }
  .no-results-calendar-p {
    font-size: 10px;
  }
}
@media screen and (max-width: 440px) {
  .mobile-datepicker-toggle span {
    font-size: 10px;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    font-size: 15px;
  }
  .personal-calendar .personal-tag .left,
  .personal-calendar .personal-tag .right {
    width: calc(100% - 25px);
    margin-left: 25px;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    left: -25px;
  }
}
</style>